import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'mj-alert',
  templateUrl: './alert.template.html',
  styleUrls: ['./alert.style.scss'],
})
export class AlertComponent implements OnInit, OnChanges {
  @Input() options: any;

  @Input() collapse: boolean;

  @Output() onButtonClick = new EventEmitter<number>();
  @Output() onDeclineClick = new EventEmitter<number>();

  constructor(private _element: ElementRef) {}

  public ngOnInit() {
    this._setOptions();
  }

  public ngOnChanges(changes) {
    this._setOptions();
  }

  public checkType(type: string) {
    return this.options.type === type;
  }

  public buttonClick(value) {
    if (this.options.success) {
      this.options.success();
    }

    this.onButtonClick.emit(value);
  }

  public declineClick(value) {
    if (this.options.decline) {
      this.options.decline();
    }

    this.onDeclineClick.emit(value);
  }

  private _setOptions() {
    this.options = Object.assign(
      {
        type: 'success',
        title: 'Ok!',
        showAccept: true,
        acceptText: 'Ok',
        declineText: 'Back',
      },
      this.options
    );
  }

  private get _elementHeight(): number {
    const el = this._element.nativeElement;
    let height = el.offsetHeight;
    const style = getComputedStyle(el);

    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
  }
}
